import React from 'react';

const ColumnHeader = ({ title }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'none'
      }}
    >
      <span>{title}</span>
      <i
        className="fa fa-sort"
        style={{ marginLeft: '5px', fontSize: '1.2em' }}
      ></i>
    </div>
  );
};

export default ColumnHeader;
